import { keepPreviousData } from '@tanstack/react-query';

import { UserGatewayMessage } from '../../../../types/UserGatewayMessage';
import { UserStatus } from '../../../../types/UserStatus';
import { queries } from '../../../common/api/queryKeys/queries';
import { usePaginationQuery } from '../../../common/hooks/usePaginationQuery';

interface ManagementUsersParams {
    page: number;
    searchQuery?: string;
    companyIds?: string[];
    groupIds?: string[];
    statuses?: UserStatus[];
}

export const useManagementUsersPagination = (params: ManagementUsersParams) => {
    const nextPage = queries.members.pagination({ ...params, page: params.page + 1 });

    return usePaginationQuery<UserGatewayMessage>({
        ...queries.members.pagination(params),
        options: { placeholderData: keepPreviousData },
        prefetchQueryKey: nextPage.queryKey,
        prefetchQueryFn: nextPage.queryFn,
    });
};
